import {
  Button,
  createTableColumn,
  Input,
  Label,
  Link,
  TableColumnDefinition,
} from "@fluentui/react-components";
import i18n from "i18next";
import React, { useState } from "react";
import { IUserDocument } from "../../../Models/IUserDocument";
import {
  CheckmarkRegular,
  DeleteRegular,
  DismissRegular,
  DocumentPdf24Regular,
  EditRegular,
  VideoClip24Regular,
} from "@fluentui/react-icons";

interface IUserDocumentProps {
  openDeleteDialog(item: string): void;
  selectedDocumentToDelete(item: IUserDocument): void;
  onChangeFileName(
    guidFilename: string,
    newFilenameWithExtension: string,
  ): void;
  hoveredRowGuid: string;
  onChangeDescription(guid: string, newDescription: string): void;
}

export function UserDocumentsColumns(props: IUserDocumentProps) {
  const [editDisplayDocFilename, setEditDisplayDocFilename] =
    useState<string>("");
  const [newDisplayDocFilename, setNewDisplayDocFilename] =
    useState<string>("");

  const [editDocDescription, setEditDocDescription] = useState<string>("");
  const [newDocDescription, setNewDocDescription] = useState<string>("");

  const columns: TableColumnDefinition<IUserDocument>[] = [
    createTableColumn<IUserDocument>({
      columnId: "docFileExtension",
      compare: (a, b) => {
        if (a.docFileExtension && b.docFileExtension) {
          return a.docFileExtension.localeCompare(b.docFileExtension);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("docFileExtensionText");
      },
      renderCell: (item) => {
        if (item.docFileExtension == "MP4") {
          return <VideoClip24Regular color="#ff6600" />;
        } else if (item.docFileExtension == "PDF") {
          return <DocumentPdf24Regular color="#ff6600" />;
        }
      },
    }),
    createTableColumn<IUserDocument>({
      columnId: "docFileName",
      compare: (a, b) => {
        if (a.docFileName && b.docFileName) {
          return a.docFileName.localeCompare(b.docFileName);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("FileName");
      },
      renderCell: (item) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            {editDisplayDocFilename != item.displayDocFileName && (
              <div>
                <Label>{item.displayDocFileName}</Label>
                {props.hoveredRowGuid == item.userObjectGuid && (
                  <Button
                    size="small"
                    appearance="transparent"
                    icon={<EditRegular />}
                    onClick={() => {
                      setEditDisplayDocFilename(item.displayDocFileName);
                      setNewDisplayDocFilename(
                        item.displayDocFileName.split(".")[0],
                      );
                    }}
                  />
                )}
              </div>
            )}
            {newDisplayDocFilename &&
              editDisplayDocFilename == item.displayDocFileName && (
                <div style={{ width: "100%" }}>
                  <Input
                    style={{ width: "95%" }}
                    defaultValue={newDisplayDocFilename}
                    onChange={(ev, data) => {
                      setNewDisplayDocFilename(data.value);
                    }}
                    contentAfter={
                      <div>
                        {"." + item.docFileExtension + " "}
                        <Button
                          appearance="transparent"
                          icon={<CheckmarkRegular color="green" />}
                          onClick={() => {
                            props.onChangeFileName(
                              item.userObjectGuid,
                              newDisplayDocFilename +
                                "." +
                                item.docFileExtension,
                            );
                            setEditDisplayDocFilename("");
                          }}
                        />
                        <Button
                          appearance="transparent"
                          onClick={() => {
                            setEditDisplayDocFilename("");
                          }}
                          icon={<DismissRegular color="red" />}
                        />
                      </div>
                    }
                  />
                </div>
              )}
            <div>
              {editDocDescription != item.description && (
                <div>
                  <Label style={{ color: "gray" }}>{item.description}</Label>
                  {props.hoveredRowGuid == item.userObjectGuid && (
                    <Button
                      size="small"
                      appearance="transparent"
                      icon={<EditRegular />}
                      onClick={() => {
                        setEditDocDescription(item.description);
                        setNewDocDescription(item.description);
                      }}
                    />
                  )}
                </div>
              )}
              {newDocDescription && editDocDescription == item.description && (
                <div style={{ width: "100%" }}>
                  <Input
                    style={{ width: "95%" }}
                    defaultValue={newDocDescription}
                    onChange={(ev, data) => {
                      setNewDocDescription(data.value);
                    }}
                    contentAfter={
                      <div>
                        {"." + item.docFileExtension + " "}
                        <Button
                          appearance="transparent"
                          icon={<CheckmarkRegular color="green" />}
                          onClick={() => {
                            props.onChangeDescription(
                              item.userObjectGuid,
                              newDocDescription,
                            );
                            setEditDocDescription("");
                          }}
                        />
                        <Button
                          appearance="transparent"
                          onClick={() => {
                            setEditDocDescription("");
                          }}
                          icon={<DismissRegular color="red" />}
                        />
                      </div>
                    }
                  />
                </div>
              )}
            </div>
          </div>
        );
      },
    }),
    createTableColumn<IUserDocument>({
      columnId: "actionsId",
      renderHeaderCell: () => {
        return i18n.t<string>("actions");
      },
      renderCell: (item) => {
        return (
          <Button
            icon={<DeleteRegular />}
            appearance="transparent"
            onClick={() => props.openDeleteDialog(item.userObjectGuid)}
          />
        );
      },
    }),
    createTableColumn<IUserDocument>({
      columnId: "createdBy.fullName",
      compare: (a, b) => {
        if (a.createdBy.fullName && b.createdBy.fullName) {
          return a.createdBy.fullName.localeCompare(b.createdBy.fullName);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("user");
      },
      renderCell: (item) => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Label>{item.createdBy.fullName}</Label>
            <Label>{item.createdBy.firma}</Label>
          </div>
        );
      },
    }),
  ];

  return columns;
}
